
import CPLoader from '@/components/globals/CPLoader.vue';
import { formatValidationMessages, validate } from '@/validation';
import { profileUpdateDetailsSchema } from '@/validation/profileUpdateSchema';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    CPLoader,
  },
})
export default class CPUpdateDetailsReminder extends Vue {
  public isCheckboxChecked: boolean = false;
  public haveChanges: boolean = false;
  public haveNoChanges: boolean = false;
  public agreeRoles: boolean = false;
  public disagreeRoles: boolean = false;
  public currentStep: number = 1;
  public firstName: string = '';
  public lastName: string = '';
  public email: string = '';
  public phone: string = '';
  public isSubmitting: boolean = false;
  public isSubmitted: boolean = false;
  public isFirstLoad: boolean = true;
  public isFinancialChanged: boolean = false;
  public hasSubIfa: boolean = false;
  public subIfa: string | null;
  public companyName: string = '';
  private excludedCompany: string = 'Capital Platforms';


  public subIfaNotProvided() {
    return (!this.subIfa || this.subIfa.trim().length === 0) && this.hasSubIfa
  }

  public created(): void {
    this.firstName = this.$store.state.profileDetails.firstName;
    this.lastName = this.$store.state.profileDetails.lastName;
    this.email = this.$store.state.profileDetails.email;
    this.phone = this.$store.state.profileDetails.phone;
    this.hasSubIfa = this.$store.state.account.details.hasSubIfa;
    this.subIfa = this.$store.state.account.details.subIfa;

    this.companyName = (this.subIfa && this.subIfa.trim().length > 0)
      ? this.subIfa
      : this.$store.state.account.details.companyName;

    console.log(this.$store)
    this.$store.dispatch('getLicenses');
  }

  public get licenses() {
    return this.$store.state.licenses || [];
  }

  get consultant() {
    return this.$store.state.account.details.consultantName;
  }

  @Watch('haveChanges')
  public onHaveChangesChanged(newVal: boolean) {
    if (newVal) this.haveNoChanges = false;
  }

  @Watch('haveNoChanges')
  public onHaveNoChangesChanged(newVal: boolean) {
    if (newVal) this.haveChanges = false;
  }

  @Watch('agreeRoles')
  public onAgreeRolesChanged(newVal: boolean) {
    if (newVal) this.disagreeRoles = false;
  }

  @Watch('disagreeRoles')
  public onDisagreeRolesChanged(newVal: boolean) {
    if (newVal) this.agreeRoles = false;
  }

  public async close() {
    this.$store.commit('toggleUpdateProfileReminderModal', false);
  }

  public proceedFromStep1() {
    if (!this.haveChanges && !this.haveNoChanges) {
      this.$store.dispatch(
        'addError',
        'Please select whether your personal and/or financial circumstances have changed.',
      );
      return;
    }
    if (!this.agreeRoles && !this.disagreeRoles) {
      this.$store.dispatch(
        'addError',
        'Please select whether you agree or disagree to the role(s) statement.',
      );
      return;
    }
    this.currentStep = 2;
  }

  private normalizeEmailList(value: string | null | undefined): string {
    return (value || '').trim().replace(/;+$/, '').trim();
  }

  private buildProfilePayload() {
    const email = this.normalizeEmailList(this.email);
    const phone = (this.phone || '').trim();

    const payload: Record<string, unknown> = {
      email,
      phone,
      financialChanged: this.isFinancialChanged,
      acceptRoleStatement: this.agreeRoles,
      detailsChanged: this.haveChanges
    };

    return payload;
  }

  public async submit() {
    if (this.haveChanges) {
      const email = this.normalizeEmailList(this.email);
      const phone = (this.phone || '').trim();

      const result = validate({ email, phone }, profileUpdateDetailsSchema);
      if (result.error) {
        const messages = formatValidationMessages(result.error.details);
        this.$store.dispatch('addError', messages.join(' '));
        return;
      }
      this.email = email;
    }

    this.isFirstLoad = false;
    this.isSubmitting = true;

    try {
      await this.$store.dispatch(
        'updateProfileReminder',
        this.buildProfilePayload(),
      );
    } finally {
      this.isSubmitting = false;
    }
  }

  public async acknowledgeSubmit() {
    this.isFirstLoad = false;
    this.isSubmitting = true;
    await this.$store.dispatch(
      'updateProfileReminder',
      this.buildProfilePayload(),
    );
    this.$store.commit('toggleUpdateProfileReminderModal', false);
    await this.$store.dispatch('clearClientToken');
    await this.$store.dispatch('logout');
    window.close();
  }
}
